import Analytics from "./analytics";
import Events from "./events";
import metadata from "./metadata";

const setup = ({
  clientId,
  appKey,
  environment = "production",
  version = "V1",
  analytics = {
    scrollThresholds: [25, 50, 75, 100],
    clickTags: ["BUTTON", "A", "SUMMARY"],
  },
}) => {
  if (!clientId || !appKey) {
    console.error("[Tracr] Error: clientId and appKey are required");
    return;
  }

  const anonymousId = metadata.getAnonymousId();
  const sessionId = metadata.getSessionId();
  const isNewAnonymousId = metadata.getIsAnonymousIdNew();

  const envs = {
    production: {
      apiUrl: "https://ingestion-api.redspine.redplatform.com.br/v1/ingest",
    },
    development: {
      apiUrl: "https://ingestion-api.redspine.dev.redplatform.com.br/v1/ingest",
    },
  };

  const api = envs[environment];

  const tracr = {
    clientId,
    appKey,
    version,
    anonymousId,
    sessionId,
    isNewAnonymousId,
    ...api,
  };

  localStorage.setItem("tracr", JSON.stringify(tracr));

  Analytics.initialize(
    {
      pageView: (pageName) => Events.pageview(pageName),
      click: (data) => Events.sendEvent("ElementClicked", data),
      scroll: (data) => Events.scroll(data.scrollDistance),
    },
    {
      scrollThresholds: analytics.scrollThresholds,
      clickTags: analytics.clickTags,
    }
  );
};

export default setup;
